var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.243 2.925C6.773 1.151 9.052 0 12.001 0s5.228 1.152 6.757 2.925C20.268 4.678 21 6.983 21 9.25c0 1.285-.6 2.843-1.357 4.34-.778 1.538-1.805 3.168-2.817 4.647a81 81 0 0 1-3.961 5.288l-.07.084-.01.013A1 1 0 0 1 12 24a1 1 0 0 1-.783-.378l-.01-.013-.07-.084-.259-.319a80.815 80.815 0 0 1-3.704-4.97c-1.012-1.478-2.039-3.108-2.817-4.646C3.601 12.093 3 10.535 3 9.25c0-2.267.732-4.572 2.243-6.325m6.758 18.481-.46-.587a79 79 0 0 1-2.715-3.712c-.988-1.443-1.961-2.993-2.683-4.42C5.4 11.22 5 10.027 5 9.25c0-1.858.602-3.678 1.758-5.019C7.896 2.911 9.616 2 12 2c2.384 0 4.104.911 5.242 2.231C18.398 5.571 19 7.392 19 9.25c0 .777-.4 1.97-1.142 3.437-.722 1.427-1.695 2.977-2.683 4.42a79 79 0 0 1-3.174 4.299",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7a2 2 0 1 0 .001 4 2 2 0 0 0 0-4M8 9a4 4 0 1 1 8.001 0 4 4 0 0 1-8 0",
    clipRule: "evenodd"
  })));
};
export default SvgLocation;